export enum LaunchErrorCodes {
  GENERAL_ERROR = 0,
  GAME_NOT_FOUND = 1,
  PARTNER_NOT_FOUND = 2,
  PARTNER_GAME_NOT_FOUND = 3,
  INVALID_CREDENTIALS = 4,
  INVALID_TOKEN = 5,
  INVALID_REQUEST = 6,
  INVALID_BET_ID = 7,
  GAME_TYPE_NOT_FOUND = 8,
  WRONG_GAME_CATEGORY = 9,
  WRONG_PLATFORM_ID = 10,
  WRONG_PARTNER_ID = 11,
  GAME_DOES_NOT_HAVE_DEMO_VERSION = 12,
  INVALID_OPERATION = 13
}
